// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v1.2.0-18-g07fcd5a",
    "hash": "g07fcd5a",
    "distance": 18,
    "tag": "v1.2.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.2.0",
        "major": 1,
        "minor": 2,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "1.2.0"
    },
    "suffix": "18-g07fcd5a",
    "semverString": "1.2.0+18.g07fcd5a",
    "version": "1.2.0"
};
/* tslint:enable */
